/* @flow */
import { ActionTypes } from 'constants/QuickPromotionConstants';
import { dispatcher } from 'lib/Dispatcher';
import errorLogger from 'utils/errorLogger';

const QuickPromotionActions = {
  recordDismissal(promotion: Object, response: string): Promise<*> {
    return new Promise(resolve => {
      promotion
        .recordDismissal(response)
        .then(() => {
          dispatcher.dispatch({
            promotion,
            type: ActionTypes.PROMOTION_DISMISSED,
          });
          resolve();
        })
        .catch(errorLogger('QuickPromotionActions recordDismissal failed'));
    });
  },
};

export default QuickPromotionActions;
